import type { GetServerSideProps } from 'next';
import { getDefaultTranslations } from '@/common/utils/translation';
import getRoute from '@/common/utils/routes';
import { parseAndValidateAccessToken } from '@/tools/auth/utils';
import LoginForm from '@/components/LoginForm';
import background from '@/../public/img/client-login-bg.jpg';
import { Box } from '@mui/material';
import Image from 'next/image';

const LOGGED_IN_DESTINATION_ROUTE = 'clientDashboard';

export default function ClientLogin() {
    return (
        <Box sx={{ height: '100vh', overflow: 'hidden' }}>
            <Image
                src={background}
                style={{
                    objectFit: 'cover',
                    width: '100%',
                    height: '100%',
                    zIndex: -1,
                    position: 'absolute',
                }}
                alt="background"
            />
            <LoginForm
                headerTranslationKey="login.clientZoneHeader"
                successReloadRoute={LOGGED_IN_DESTINATION_ROUTE}
                fromClientZone={true}
            />
        </Box>
    );
}

export const getServerSideProps: GetServerSideProps = async ({
    req,
    locale,
}) => {
    const translations = await getDefaultTranslations(locale);

    const isAccessTokenValid = parseAndValidateAccessToken(req.headers?.cookie);

    if (isAccessTokenValid) {
        return {
            redirect: {
                destination: getRoute(LOGGED_IN_DESTINATION_ROUTE).pathname,
                permanent: false,
            },
        };
    }

    return {
        props: {
            ...translations,
        },
    };
};
